import React, { createRef, useContext, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './AllForBigPicPersonList.scss';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import FolloweeDetail from '../Followee/FolloweeDetail';
import uPerson from '../Followee/usePerson';
import stat from '../../utils/stat';
import { alpha } from '../../utils/color';
import { ThemeContext } from '../../store/ThemeProvider';

interface IAllForBigPicPersonList {
  rootStore?: RootStore;
  personid: string;
  imageid?: string;
  onClose: () => void;
  maybe: any[];
  faceurl?: string;
}

const containerEl = document.createElement('div');
containerEl.setAttribute('id', 'big-pic-person-list');
const AllForBigPicPersonList = function(props: IAllForBigPicPersonList) {
  const { relationStore } = props.rootStore!;
  const {
    backgroundColor,
    componentColor,
    mainColor,
    h1Color,
    h2Color
  } = useContext(ThemeContext);
  useEffect(() => {
    document.body.appendChild(containerEl);
    return () => {
      document.body.removeChild(containerEl);
    };
  }, []);

  // 反正都应该先获取一次人物信息，避免看不到头像列表
  useEffect(() => {
    // window.dataDetail && galleryStore.getPersonList(window.dataDetail.id + '', 1);
  }, []);
  const getPerson = (personid: number, imageid?: string, faceurl?:string) =>
    uPerson(relationStore, personid, imageid, undefined, faceurl);

  const setCurrentPerson = (id: string, imageid?: string, faceurl?:string) => {
    //setCurrentFollowId(id);
    getPerson(+id, imageid, faceurl);
    stat.event('face_click');
  };

  const { personid, imageid, maybe, faceurl} = props;

  useEffect(() => {
    if (personid) {
      getPerson(+personid, imageid, faceurl);
    }
  }, [personid, imageid]);
  const wrapperEle = createRef<HTMLDivElement>();

  if (!personid) {
    return null;
  }

  return createPortal(
    <div
      className="all-for-big-pic-person-list ignore-move"
      style={{ backgroundColor: alpha(backgroundColor, 1) }}
      ref={wrapperEle}
      onClick={e => e.stopPropagation()}
    >
      <FolloweeDetail
        person={relationStore.person || {}}
        personAlbum={relationStore.personAlbum || []}
        onClickPerson={setCurrentPerson}
        onBack={() => {
          relationStore.clearCurrentPerson();
          props.onClose();
        }}
      />
    </div>,
    containerEl
  );
};

export default inject('rootStore')(observer(AllForBigPicPersonList));
